import { getEnv } from "@/utils/index";

// 全局环境变量
const globalConst = {
  serverUrl: getEnv("SERVER_URL"),
  accessToken: "rantion-erp-accessToken",
  userNo: "rantion-erp-userNo",
  iamClientId: getEnv("IAM_CLIENT_ID"), // iam id
  bpmOrigin: getEnv("BPM_ORIGIN"), // bpm 域名
  bpmFormOrigin: getEnv("BPM_FORM_ORIGIN"), // bpmForm 域名
  iamOrigin: getEnv("RAP_ORIGIN"), // iam 域名
  signInUrl: "", // 单点URl
};
globalConst.signInUrl = `${globalConst.iamOrigin}/sign/authz/oauth/v20/authorize?client_id=${globalConst.iamClientId}&response_type=code`;
(window as any).BPM_URL = globalConst.bpmOrigin;
(window as any).BPM_FORM_URL = globalConst.bpmFormOrigin;
(window as any).__POWERED_BY_QIANKUN__ = true;
export default globalConst;
